import { default as _91slug_93msfiAekumQMeta } from "/app/pages/[slug].vue?macro=true";
import { default as advanced_searchdJETlAc1FqMeta } from "/app/pages/advanced_search.vue?macro=true";
import { default as _91slug_93hU7c4WueEYMeta } from "/app/pages/analyses/[slug].vue?macro=true";
import { default as indexbxwpH2QTR8Meta } from "/app/pages/analyses/index.vue?macro=true";
import { default as _91slug_93Bdh0kXWUBUMeta } from "/app/pages/analysis/[slug].vue?macro=true";
import { default as _91slug_93yJvSWcfzguMeta } from "/app/pages/audio/[slug].vue?macro=true";
import { default as articlesbZUBiouoxoMeta } from "/app/pages/author/[slug]/articles.vue?macro=true";
import { default as _91slug_93py3nE8AUKSMeta } from "/app/pages/collection/[slug].vue?macro=true";
import { default as collectionsTOAtvWS4fdMeta } from "/app/pages/collections.vue?macro=true";
import { default as _91slug_93g4j4onldlfMeta } from "/app/pages/collectivity/[slug].vue?macro=true";
import { default as analysiscCatc7oDG7Meta } from "/app/pages/composer/[slug]/analysis.vue?macro=true";
import { default as articlesNSkJj4SvkdMeta } from "/app/pages/composer/[slug]/articles.vue?macro=true";
import { default as audiosBdCRikhdocMeta } from "/app/pages/composer/[slug]/audios.vue?macro=true";
import { default as biographyeH9ShBd8vPMeta } from "/app/pages/composer/[slug]/biography.vue?macro=true";
import { default as floraiGvJ2vfsqWMeta } from "/app/pages/composer/[slug]/flora.vue?macro=true";
import { default as indexn7xcgvUjPNMeta } from "/app/pages/composer/[slug]/index.vue?macro=true";
import { default as resources7RGpfksORCMeta } from "/app/pages/composer/[slug]/resources.vue?macro=true";
import { default as videos3rZVPHC4mfMeta } from "/app/pages/composer/[slug]/videos.vue?macro=true";
import { default as workcoursenJSthwUIThMeta } from "/app/pages/composer/[slug]/workcourse.vue?macro=true";
import { default as worksByDateZpylvvlo1rMeta } from "/app/pages/composer/[slug]/worksByDate.vue?macro=true";
import { default as worksByKindTSEan2czuIMeta } from "/app/pages/composer/[slug]/worksByKind.vue?macro=true";
import { default as _91slug_93NHBz7ClbRgMeta } from "/app/pages/composers/composers/[slug].vue?macro=true";
import { default as contactV6oPJjs9RyMeta } from "/app/pages/contact.vue?macro=true";
import { default as _91slug_93KhwtoMY9GMMeta } from "/app/pages/definition/[slug].vue?macro=true";
import { default as definitions8WbLVtnOv1Meta } from "/app/pages/definitions.vue?macro=true";
import { default as _91slug_93QehARZdqsPMeta } from "/app/pages/embed/media/[slug].vue?macro=true";
import { default as _91slug_93sUbkJDVPd1Meta } from "/app/pages/event/[slug].vue?macro=true";
import { default as _91slug_93PTnCmSABQJMeta } from "/app/pages/flat/[slug].vue?macro=true";
import { default as booking_successd8xK3jDOUgMeta } from "/app/pages/flora/[slug]/booking_success.vue?macro=true";
import { default as bookingOdokhe63JgMeta } from "/app/pages/flora/[slug]/booking.vue?macro=true";
import { default as indexC65UD917tYMeta } from "/app/pages/flora/[slug]/index.vue?macro=true";
import { default as composersE7TAIwFus9Meta } from "/app/pages/index-items/composers.vue?macro=true";
import { default as worksm7VtpSH8qOMeta } from "/app/pages/index-items/works.vue?macro=true";
import { default as indexN6pT4Un8hYMeta } from "/app/pages/index.vue?macro=true";
import { default as _91slug_93GP8jY736bZMeta } from "/app/pages/media/[slug].vue?macro=true";
import { default as _91slug_93lbuAbjEt1cMeta } from "/app/pages/numericDocument/[slug].vue?macro=true";
import { default as _91slug_93h62tM3CXS2Meta } from "/app/pages/person/[slug].vue?macro=true";
import { default as search_resultg4a88VlqozMeta } from "/app/pages/search_result.vue?macro=true";
import { default as search_staff4VEn8lkVdSMeta } from "/app/pages/search_staff.vue?macro=true";
import { default as _91slug_934e0AdxEPcrMeta } from "/app/pages/set/[slug].vue?macro=true";
import { default as covercUP5VZK71cMeta } from "/app/pages/sidney/[slug]/cover.vue?macro=true";
import { default as indexuWXLMxq3TpMeta } from "/app/pages/sidney/[slug]/index.vue?macro=true";
import { default as surveyDkY5SrbsmrMeta } from "/app/pages/sidney/[slug]/survey.vue?macro=true";
import { default as _91slug_93CfyP7wAjcNMeta } from "/app/pages/sidney/brands/[slug].vue?macro=true";
import { default as indexEwMNvgp0VJMeta } from "/app/pages/sidney/brands/index.vue?macro=true";
import { default as documentation_45eniASRUu9pDpMeta } from "/app/pages/sidney/documentation/documentation-en.vue?macro=true";
import { default as documentation_45frzVu9neCdWFMeta } from "/app/pages/sidney/documentation/documentation-fr.vue?macro=true";
import { default as guidelinesLKnt9iNq8mMeta } from "/app/pages/sidney/documentation/guidelines.vue?macro=true";
import { default as index3wsCBsVyT1Meta } from "/app/pages/sidney/index.vue?macro=true";
import { default as _91slug_93rPouQJ15vxMeta } from "/app/pages/sidney/musicEquipments/[slug].vue?macro=true";
import { default as index7AiPpb6Fu5Meta } from "/app/pages/sidney/musicEquipments/index.vue?macro=true";
import { default as myVersionsHzyzmTaxCtMeta } from "/app/pages/sidney/myVersions.vue?macro=true";
import { default as _91slug_93ctQTwCVCWTMeta } from "/app/pages/sidney/orderby/[slug].vue?macro=true";
import { default as work_45without_45versionsIgQh8ABAVKMeta } from "/app/pages/sidney/work-without-versions.vue?macro=true";
import { default as workWithoutVersionVhNdjyrALVMeta } from "/app/pages/sidney/workWithoutVersion.vue?macro=true";
import { default as _91slug_936YKsg4LvdSMeta } from "/app/pages/tag/[slug].vue?macro=true";
import { default as _91slug_93VACrgYtOUYMeta } from "/app/pages/video/[slug].vue?macro=true";
import { default as indexFYVBQJGfNjMeta } from "/app/pages/work/[slug]/index.vue?macro=true";
import { default as _91slug_93G10iNVRzKxMeta } from "/app/pages/work/composition-year/[slug].vue?macro=true";
import { default as _91slug_93qeaeszMjUFMeta } from "/app/pages/work/creation-year/[slug].vue?macro=true";
import { default as _91slug_937z7txrvYKbMeta } from "/app/pages/work/genre/[slug].vue?macro=true";
import { default as _91slug_93d283ziE4ElMeta } from "/app/pages/works/work/[slug].vue?macro=true";
export default [
  {
    name: _91slug_93msfiAekumQMeta?.name ?? "slug",
    path: _91slug_93msfiAekumQMeta?.path ?? "/:slug()",
    meta: _91slug_93msfiAekumQMeta || {},
    alias: _91slug_93msfiAekumQMeta?.alias || [],
    redirect: _91slug_93msfiAekumQMeta?.redirect || undefined,
    component: () => import("/app/pages/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93msfiAekumQMeta?.name ?? "slug___fr",
    path: _91slug_93msfiAekumQMeta?.path ?? "/fr/:slug()",
    meta: _91slug_93msfiAekumQMeta || {},
    alias: _91slug_93msfiAekumQMeta?.alias || [],
    redirect: _91slug_93msfiAekumQMeta?.redirect || undefined,
    component: () => import("/app/pages/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93msfiAekumQMeta?.name ?? "slug___en",
    path: _91slug_93msfiAekumQMeta?.path ?? "/en/:slug()",
    meta: _91slug_93msfiAekumQMeta || {},
    alias: _91slug_93msfiAekumQMeta?.alias || [],
    redirect: _91slug_93msfiAekumQMeta?.redirect || undefined,
    component: () => import("/app/pages/[slug].vue").then(m => m.default || m)
  },
  {
    name: advanced_searchdJETlAc1FqMeta?.name ?? "advanced_search",
    path: advanced_searchdJETlAc1FqMeta?.path ?? "/advanced_search",
    meta: advanced_searchdJETlAc1FqMeta || {},
    alias: advanced_searchdJETlAc1FqMeta?.alias || [],
    redirect: advanced_searchdJETlAc1FqMeta?.redirect || undefined,
    component: () => import("/app/pages/advanced_search.vue").then(m => m.default || m)
  },
  {
    name: advanced_searchdJETlAc1FqMeta?.name ?? "advanced_search___fr",
    path: advanced_searchdJETlAc1FqMeta?.path ?? "/fr/advanced_search",
    meta: advanced_searchdJETlAc1FqMeta || {},
    alias: advanced_searchdJETlAc1FqMeta?.alias || [],
    redirect: advanced_searchdJETlAc1FqMeta?.redirect || undefined,
    component: () => import("/app/pages/advanced_search.vue").then(m => m.default || m)
  },
  {
    name: advanced_searchdJETlAc1FqMeta?.name ?? "advanced_search___en",
    path: advanced_searchdJETlAc1FqMeta?.path ?? "/en/advanced_search",
    meta: advanced_searchdJETlAc1FqMeta || {},
    alias: advanced_searchdJETlAc1FqMeta?.alias || [],
    redirect: advanced_searchdJETlAc1FqMeta?.redirect || undefined,
    component: () => import("/app/pages/advanced_search.vue").then(m => m.default || m)
  },
  {
    name: _91slug_93hU7c4WueEYMeta?.name ?? "analyses-slug",
    path: _91slug_93hU7c4WueEYMeta?.path ?? "/analyses/:slug()",
    meta: _91slug_93hU7c4WueEYMeta || {},
    alias: _91slug_93hU7c4WueEYMeta?.alias || [],
    redirect: _91slug_93hU7c4WueEYMeta?.redirect || undefined,
    component: () => import("/app/pages/analyses/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93hU7c4WueEYMeta?.name ?? "analyses-slug___fr",
    path: _91slug_93hU7c4WueEYMeta?.path ?? "/fr/analyses/:slug()",
    meta: _91slug_93hU7c4WueEYMeta || {},
    alias: _91slug_93hU7c4WueEYMeta?.alias || [],
    redirect: _91slug_93hU7c4WueEYMeta?.redirect || undefined,
    component: () => import("/app/pages/analyses/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93hU7c4WueEYMeta?.name ?? "analyses-slug___en",
    path: _91slug_93hU7c4WueEYMeta?.path ?? "/en/analyses/:slug()",
    meta: _91slug_93hU7c4WueEYMeta || {},
    alias: _91slug_93hU7c4WueEYMeta?.alias || [],
    redirect: _91slug_93hU7c4WueEYMeta?.redirect || undefined,
    component: () => import("/app/pages/analyses/[slug].vue").then(m => m.default || m)
  },
  {
    name: indexbxwpH2QTR8Meta?.name ?? "analyses",
    path: indexbxwpH2QTR8Meta?.path ?? "/analyses",
    meta: indexbxwpH2QTR8Meta || {},
    alias: indexbxwpH2QTR8Meta?.alias || [],
    redirect: indexbxwpH2QTR8Meta?.redirect || undefined,
    component: () => import("/app/pages/analyses/index.vue").then(m => m.default || m)
  },
  {
    name: indexbxwpH2QTR8Meta?.name ?? "analyses___fr",
    path: indexbxwpH2QTR8Meta?.path ?? "/fr/analyses",
    meta: indexbxwpH2QTR8Meta || {},
    alias: indexbxwpH2QTR8Meta?.alias || [],
    redirect: indexbxwpH2QTR8Meta?.redirect || undefined,
    component: () => import("/app/pages/analyses/index.vue").then(m => m.default || m)
  },
  {
    name: indexbxwpH2QTR8Meta?.name ?? "analyses___en",
    path: indexbxwpH2QTR8Meta?.path ?? "/en/analyses",
    meta: indexbxwpH2QTR8Meta || {},
    alias: indexbxwpH2QTR8Meta?.alias || [],
    redirect: indexbxwpH2QTR8Meta?.redirect || undefined,
    component: () => import("/app/pages/analyses/index.vue").then(m => m.default || m)
  },
  {
    name: _91slug_93Bdh0kXWUBUMeta?.name ?? "analysis-slug",
    path: _91slug_93Bdh0kXWUBUMeta?.path ?? "/analysis/:slug()",
    meta: _91slug_93Bdh0kXWUBUMeta || {},
    alias: _91slug_93Bdh0kXWUBUMeta?.alias || [],
    redirect: _91slug_93Bdh0kXWUBUMeta?.redirect || undefined,
    component: () => import("/app/pages/analysis/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93Bdh0kXWUBUMeta?.name ?? "analysis-slug___fr",
    path: _91slug_93Bdh0kXWUBUMeta?.path ?? "/fr/analysis/:slug()",
    meta: _91slug_93Bdh0kXWUBUMeta || {},
    alias: _91slug_93Bdh0kXWUBUMeta?.alias || [],
    redirect: _91slug_93Bdh0kXWUBUMeta?.redirect || undefined,
    component: () => import("/app/pages/analysis/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93Bdh0kXWUBUMeta?.name ?? "analysis-slug___en",
    path: _91slug_93Bdh0kXWUBUMeta?.path ?? "/en/analysis/:slug()",
    meta: _91slug_93Bdh0kXWUBUMeta || {},
    alias: _91slug_93Bdh0kXWUBUMeta?.alias || [],
    redirect: _91slug_93Bdh0kXWUBUMeta?.redirect || undefined,
    component: () => import("/app/pages/analysis/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93yJvSWcfzguMeta?.name ?? "audio-slug",
    path: _91slug_93yJvSWcfzguMeta?.path ?? "/audio/:slug()",
    meta: _91slug_93yJvSWcfzguMeta || {},
    alias: _91slug_93yJvSWcfzguMeta?.alias || [],
    redirect: _91slug_93yJvSWcfzguMeta?.redirect || undefined,
    component: () => import("/app/pages/audio/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93yJvSWcfzguMeta?.name ?? "audio-slug___fr",
    path: _91slug_93yJvSWcfzguMeta?.path ?? "/fr/audio/:slug()",
    meta: _91slug_93yJvSWcfzguMeta || {},
    alias: _91slug_93yJvSWcfzguMeta?.alias || [],
    redirect: _91slug_93yJvSWcfzguMeta?.redirect || undefined,
    component: () => import("/app/pages/audio/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93yJvSWcfzguMeta?.name ?? "audio-slug___en",
    path: _91slug_93yJvSWcfzguMeta?.path ?? "/en/audio/:slug()",
    meta: _91slug_93yJvSWcfzguMeta || {},
    alias: _91slug_93yJvSWcfzguMeta?.alias || [],
    redirect: _91slug_93yJvSWcfzguMeta?.redirect || undefined,
    component: () => import("/app/pages/audio/[slug].vue").then(m => m.default || m)
  },
  {
    name: articlesbZUBiouoxoMeta?.name ?? "author-slug-articles",
    path: articlesbZUBiouoxoMeta?.path ?? "/author/:slug()/articles",
    meta: articlesbZUBiouoxoMeta || {},
    alias: articlesbZUBiouoxoMeta?.alias || [],
    redirect: articlesbZUBiouoxoMeta?.redirect || undefined,
    component: () => import("/app/pages/author/[slug]/articles.vue").then(m => m.default || m)
  },
  {
    name: articlesbZUBiouoxoMeta?.name ?? "author-slug-articles___fr",
    path: articlesbZUBiouoxoMeta?.path ?? "/fr/author/:slug()/articles",
    meta: articlesbZUBiouoxoMeta || {},
    alias: articlesbZUBiouoxoMeta?.alias || [],
    redirect: articlesbZUBiouoxoMeta?.redirect || undefined,
    component: () => import("/app/pages/author/[slug]/articles.vue").then(m => m.default || m)
  },
  {
    name: articlesbZUBiouoxoMeta?.name ?? "author-slug-articles___en",
    path: articlesbZUBiouoxoMeta?.path ?? "/en/author/:slug()/articles",
    meta: articlesbZUBiouoxoMeta || {},
    alias: articlesbZUBiouoxoMeta?.alias || [],
    redirect: articlesbZUBiouoxoMeta?.redirect || undefined,
    component: () => import("/app/pages/author/[slug]/articles.vue").then(m => m.default || m)
  },
  {
    name: _91slug_93py3nE8AUKSMeta?.name ?? "collection-slug",
    path: _91slug_93py3nE8AUKSMeta?.path ?? "/collection/:slug()",
    meta: _91slug_93py3nE8AUKSMeta || {},
    alias: _91slug_93py3nE8AUKSMeta?.alias || [],
    redirect: _91slug_93py3nE8AUKSMeta?.redirect || undefined,
    component: () => import("/app/pages/collection/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93py3nE8AUKSMeta?.name ?? "collection-slug___fr",
    path: _91slug_93py3nE8AUKSMeta?.path ?? "/fr/collection/:slug()",
    meta: _91slug_93py3nE8AUKSMeta || {},
    alias: _91slug_93py3nE8AUKSMeta?.alias || [],
    redirect: _91slug_93py3nE8AUKSMeta?.redirect || undefined,
    component: () => import("/app/pages/collection/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93py3nE8AUKSMeta?.name ?? "collection-slug___en",
    path: _91slug_93py3nE8AUKSMeta?.path ?? "/en/collection/:slug()",
    meta: _91slug_93py3nE8AUKSMeta || {},
    alias: _91slug_93py3nE8AUKSMeta?.alias || [],
    redirect: _91slug_93py3nE8AUKSMeta?.redirect || undefined,
    component: () => import("/app/pages/collection/[slug].vue").then(m => m.default || m)
  },
  {
    name: collectionsTOAtvWS4fdMeta?.name ?? "collections",
    path: collectionsTOAtvWS4fdMeta?.path ?? "/collections",
    meta: collectionsTOAtvWS4fdMeta || {},
    alias: collectionsTOAtvWS4fdMeta?.alias || [],
    redirect: collectionsTOAtvWS4fdMeta?.redirect || undefined,
    component: () => import("/app/pages/collections.vue").then(m => m.default || m)
  },
  {
    name: collectionsTOAtvWS4fdMeta?.name ?? "collections___fr",
    path: collectionsTOAtvWS4fdMeta?.path ?? "/fr/collections",
    meta: collectionsTOAtvWS4fdMeta || {},
    alias: collectionsTOAtvWS4fdMeta?.alias || [],
    redirect: collectionsTOAtvWS4fdMeta?.redirect || undefined,
    component: () => import("/app/pages/collections.vue").then(m => m.default || m)
  },
  {
    name: collectionsTOAtvWS4fdMeta?.name ?? "collections___en",
    path: collectionsTOAtvWS4fdMeta?.path ?? "/en/collections",
    meta: collectionsTOAtvWS4fdMeta || {},
    alias: collectionsTOAtvWS4fdMeta?.alias || [],
    redirect: collectionsTOAtvWS4fdMeta?.redirect || undefined,
    component: () => import("/app/pages/collections.vue").then(m => m.default || m)
  },
  {
    name: _91slug_93g4j4onldlfMeta?.name ?? "collectivity-slug",
    path: _91slug_93g4j4onldlfMeta?.path ?? "/collectivity/:slug()",
    meta: _91slug_93g4j4onldlfMeta || {},
    alias: _91slug_93g4j4onldlfMeta?.alias || [],
    redirect: _91slug_93g4j4onldlfMeta?.redirect || undefined,
    component: () => import("/app/pages/collectivity/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93g4j4onldlfMeta?.name ?? "collectivity-slug___fr",
    path: _91slug_93g4j4onldlfMeta?.path ?? "/fr/collectivity/:slug()",
    meta: _91slug_93g4j4onldlfMeta || {},
    alias: _91slug_93g4j4onldlfMeta?.alias || [],
    redirect: _91slug_93g4j4onldlfMeta?.redirect || undefined,
    component: () => import("/app/pages/collectivity/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93g4j4onldlfMeta?.name ?? "collectivity-slug___en",
    path: _91slug_93g4j4onldlfMeta?.path ?? "/en/collectivity/:slug()",
    meta: _91slug_93g4j4onldlfMeta || {},
    alias: _91slug_93g4j4onldlfMeta?.alias || [],
    redirect: _91slug_93g4j4onldlfMeta?.redirect || undefined,
    component: () => import("/app/pages/collectivity/[slug].vue").then(m => m.default || m)
  },
  {
    name: analysiscCatc7oDG7Meta?.name ?? "composer-slug-analysis",
    path: analysiscCatc7oDG7Meta?.path ?? "/composer/:slug()/analysis",
    meta: analysiscCatc7oDG7Meta || {},
    alias: analysiscCatc7oDG7Meta?.alias || [],
    redirect: analysiscCatc7oDG7Meta?.redirect || undefined,
    component: () => import("/app/pages/composer/[slug]/analysis.vue").then(m => m.default || m)
  },
  {
    name: analysiscCatc7oDG7Meta?.name ?? "composer-slug-analysis___fr",
    path: analysiscCatc7oDG7Meta?.path ?? "/fr/composer/:slug()/analysis",
    meta: analysiscCatc7oDG7Meta || {},
    alias: analysiscCatc7oDG7Meta?.alias || [],
    redirect: analysiscCatc7oDG7Meta?.redirect || undefined,
    component: () => import("/app/pages/composer/[slug]/analysis.vue").then(m => m.default || m)
  },
  {
    name: analysiscCatc7oDG7Meta?.name ?? "composer-slug-analysis___en",
    path: analysiscCatc7oDG7Meta?.path ?? "/en/composer/:slug()/analysis",
    meta: analysiscCatc7oDG7Meta || {},
    alias: analysiscCatc7oDG7Meta?.alias || [],
    redirect: analysiscCatc7oDG7Meta?.redirect || undefined,
    component: () => import("/app/pages/composer/[slug]/analysis.vue").then(m => m.default || m)
  },
  {
    name: articlesNSkJj4SvkdMeta?.name ?? "composer-slug-articles",
    path: articlesNSkJj4SvkdMeta?.path ?? "/composer/:slug()/articles",
    meta: articlesNSkJj4SvkdMeta || {},
    alias: articlesNSkJj4SvkdMeta?.alias || [],
    redirect: articlesNSkJj4SvkdMeta?.redirect || undefined,
    component: () => import("/app/pages/composer/[slug]/articles.vue").then(m => m.default || m)
  },
  {
    name: articlesNSkJj4SvkdMeta?.name ?? "composer-slug-articles___fr",
    path: articlesNSkJj4SvkdMeta?.path ?? "/fr/composer/:slug()/articles",
    meta: articlesNSkJj4SvkdMeta || {},
    alias: articlesNSkJj4SvkdMeta?.alias || [],
    redirect: articlesNSkJj4SvkdMeta?.redirect || undefined,
    component: () => import("/app/pages/composer/[slug]/articles.vue").then(m => m.default || m)
  },
  {
    name: articlesNSkJj4SvkdMeta?.name ?? "composer-slug-articles___en",
    path: articlesNSkJj4SvkdMeta?.path ?? "/en/composer/:slug()/articles",
    meta: articlesNSkJj4SvkdMeta || {},
    alias: articlesNSkJj4SvkdMeta?.alias || [],
    redirect: articlesNSkJj4SvkdMeta?.redirect || undefined,
    component: () => import("/app/pages/composer/[slug]/articles.vue").then(m => m.default || m)
  },
  {
    name: audiosBdCRikhdocMeta?.name ?? "composer-slug-audios",
    path: audiosBdCRikhdocMeta?.path ?? "/composer/:slug()/audios",
    meta: audiosBdCRikhdocMeta || {},
    alias: audiosBdCRikhdocMeta?.alias || [],
    redirect: audiosBdCRikhdocMeta?.redirect || undefined,
    component: () => import("/app/pages/composer/[slug]/audios.vue").then(m => m.default || m)
  },
  {
    name: audiosBdCRikhdocMeta?.name ?? "composer-slug-audios___fr",
    path: audiosBdCRikhdocMeta?.path ?? "/fr/composer/:slug()/audios",
    meta: audiosBdCRikhdocMeta || {},
    alias: audiosBdCRikhdocMeta?.alias || [],
    redirect: audiosBdCRikhdocMeta?.redirect || undefined,
    component: () => import("/app/pages/composer/[slug]/audios.vue").then(m => m.default || m)
  },
  {
    name: audiosBdCRikhdocMeta?.name ?? "composer-slug-audios___en",
    path: audiosBdCRikhdocMeta?.path ?? "/en/composer/:slug()/audios",
    meta: audiosBdCRikhdocMeta || {},
    alias: audiosBdCRikhdocMeta?.alias || [],
    redirect: audiosBdCRikhdocMeta?.redirect || undefined,
    component: () => import("/app/pages/composer/[slug]/audios.vue").then(m => m.default || m)
  },
  {
    name: biographyeH9ShBd8vPMeta?.name ?? "composer-slug-biography",
    path: biographyeH9ShBd8vPMeta?.path ?? "/composer/:slug()/biography",
    meta: biographyeH9ShBd8vPMeta || {},
    alias: biographyeH9ShBd8vPMeta?.alias || [],
    redirect: biographyeH9ShBd8vPMeta?.redirect || undefined,
    component: () => import("/app/pages/composer/[slug]/biography.vue").then(m => m.default || m)
  },
  {
    name: biographyeH9ShBd8vPMeta?.name ?? "composer-slug-biography___fr",
    path: biographyeH9ShBd8vPMeta?.path ?? "/fr/composer/:slug()/biography",
    meta: biographyeH9ShBd8vPMeta || {},
    alias: biographyeH9ShBd8vPMeta?.alias || [],
    redirect: biographyeH9ShBd8vPMeta?.redirect || undefined,
    component: () => import("/app/pages/composer/[slug]/biography.vue").then(m => m.default || m)
  },
  {
    name: biographyeH9ShBd8vPMeta?.name ?? "composer-slug-biography___en",
    path: biographyeH9ShBd8vPMeta?.path ?? "/en/composer/:slug()/biography",
    meta: biographyeH9ShBd8vPMeta || {},
    alias: biographyeH9ShBd8vPMeta?.alias || [],
    redirect: biographyeH9ShBd8vPMeta?.redirect || undefined,
    component: () => import("/app/pages/composer/[slug]/biography.vue").then(m => m.default || m)
  },
  {
    name: floraiGvJ2vfsqWMeta?.name ?? "composer-slug-flora",
    path: floraiGvJ2vfsqWMeta?.path ?? "/composer/:slug()/flora",
    meta: floraiGvJ2vfsqWMeta || {},
    alias: floraiGvJ2vfsqWMeta?.alias || [],
    redirect: floraiGvJ2vfsqWMeta?.redirect || undefined,
    component: () => import("/app/pages/composer/[slug]/flora.vue").then(m => m.default || m)
  },
  {
    name: floraiGvJ2vfsqWMeta?.name ?? "composer-slug-flora___fr",
    path: floraiGvJ2vfsqWMeta?.path ?? "/fr/composer/:slug()/flora",
    meta: floraiGvJ2vfsqWMeta || {},
    alias: floraiGvJ2vfsqWMeta?.alias || [],
    redirect: floraiGvJ2vfsqWMeta?.redirect || undefined,
    component: () => import("/app/pages/composer/[slug]/flora.vue").then(m => m.default || m)
  },
  {
    name: floraiGvJ2vfsqWMeta?.name ?? "composer-slug-flora___en",
    path: floraiGvJ2vfsqWMeta?.path ?? "/en/composer/:slug()/flora",
    meta: floraiGvJ2vfsqWMeta || {},
    alias: floraiGvJ2vfsqWMeta?.alias || [],
    redirect: floraiGvJ2vfsqWMeta?.redirect || undefined,
    component: () => import("/app/pages/composer/[slug]/flora.vue").then(m => m.default || m)
  },
  {
    name: indexn7xcgvUjPNMeta?.name ?? "composer-slug",
    path: indexn7xcgvUjPNMeta?.path ?? "/composer/:slug()",
    meta: indexn7xcgvUjPNMeta || {},
    alias: indexn7xcgvUjPNMeta?.alias || [],
    redirect: indexn7xcgvUjPNMeta?.redirect || undefined,
    component: () => import("/app/pages/composer/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexn7xcgvUjPNMeta?.name ?? "composer-slug___fr",
    path: indexn7xcgvUjPNMeta?.path ?? "/fr/composer/:slug()",
    meta: indexn7xcgvUjPNMeta || {},
    alias: indexn7xcgvUjPNMeta?.alias || [],
    redirect: indexn7xcgvUjPNMeta?.redirect || undefined,
    component: () => import("/app/pages/composer/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexn7xcgvUjPNMeta?.name ?? "composer-slug___en",
    path: indexn7xcgvUjPNMeta?.path ?? "/en/composer/:slug()",
    meta: indexn7xcgvUjPNMeta || {},
    alias: indexn7xcgvUjPNMeta?.alias || [],
    redirect: indexn7xcgvUjPNMeta?.redirect || undefined,
    component: () => import("/app/pages/composer/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: resources7RGpfksORCMeta?.name ?? "composer-slug-resources",
    path: resources7RGpfksORCMeta?.path ?? "/composer/:slug()/resources",
    meta: resources7RGpfksORCMeta || {},
    alias: resources7RGpfksORCMeta?.alias || [],
    redirect: resources7RGpfksORCMeta?.redirect || undefined,
    component: () => import("/app/pages/composer/[slug]/resources.vue").then(m => m.default || m)
  },
  {
    name: resources7RGpfksORCMeta?.name ?? "composer-slug-resources___fr",
    path: resources7RGpfksORCMeta?.path ?? "/fr/composer/:slug()/resources",
    meta: resources7RGpfksORCMeta || {},
    alias: resources7RGpfksORCMeta?.alias || [],
    redirect: resources7RGpfksORCMeta?.redirect || undefined,
    component: () => import("/app/pages/composer/[slug]/resources.vue").then(m => m.default || m)
  },
  {
    name: resources7RGpfksORCMeta?.name ?? "composer-slug-resources___en",
    path: resources7RGpfksORCMeta?.path ?? "/en/composer/:slug()/resources",
    meta: resources7RGpfksORCMeta || {},
    alias: resources7RGpfksORCMeta?.alias || [],
    redirect: resources7RGpfksORCMeta?.redirect || undefined,
    component: () => import("/app/pages/composer/[slug]/resources.vue").then(m => m.default || m)
  },
  {
    name: videos3rZVPHC4mfMeta?.name ?? "composer-slug-videos",
    path: videos3rZVPHC4mfMeta?.path ?? "/composer/:slug()/videos",
    meta: videos3rZVPHC4mfMeta || {},
    alias: videos3rZVPHC4mfMeta?.alias || [],
    redirect: videos3rZVPHC4mfMeta?.redirect || undefined,
    component: () => import("/app/pages/composer/[slug]/videos.vue").then(m => m.default || m)
  },
  {
    name: videos3rZVPHC4mfMeta?.name ?? "composer-slug-videos___fr",
    path: videos3rZVPHC4mfMeta?.path ?? "/fr/composer/:slug()/videos",
    meta: videos3rZVPHC4mfMeta || {},
    alias: videos3rZVPHC4mfMeta?.alias || [],
    redirect: videos3rZVPHC4mfMeta?.redirect || undefined,
    component: () => import("/app/pages/composer/[slug]/videos.vue").then(m => m.default || m)
  },
  {
    name: videos3rZVPHC4mfMeta?.name ?? "composer-slug-videos___en",
    path: videos3rZVPHC4mfMeta?.path ?? "/en/composer/:slug()/videos",
    meta: videos3rZVPHC4mfMeta || {},
    alias: videos3rZVPHC4mfMeta?.alias || [],
    redirect: videos3rZVPHC4mfMeta?.redirect || undefined,
    component: () => import("/app/pages/composer/[slug]/videos.vue").then(m => m.default || m)
  },
  {
    name: workcoursenJSthwUIThMeta?.name ?? "composer-slug-workcourse",
    path: workcoursenJSthwUIThMeta?.path ?? "/composer/:slug()/workcourse",
    meta: workcoursenJSthwUIThMeta || {},
    alias: workcoursenJSthwUIThMeta?.alias || [],
    redirect: workcoursenJSthwUIThMeta?.redirect || undefined,
    component: () => import("/app/pages/composer/[slug]/workcourse.vue").then(m => m.default || m)
  },
  {
    name: workcoursenJSthwUIThMeta?.name ?? "composer-slug-workcourse___fr",
    path: workcoursenJSthwUIThMeta?.path ?? "/fr/composer/:slug()/workcourse",
    meta: workcoursenJSthwUIThMeta || {},
    alias: workcoursenJSthwUIThMeta?.alias || [],
    redirect: workcoursenJSthwUIThMeta?.redirect || undefined,
    component: () => import("/app/pages/composer/[slug]/workcourse.vue").then(m => m.default || m)
  },
  {
    name: workcoursenJSthwUIThMeta?.name ?? "composer-slug-workcourse___en",
    path: workcoursenJSthwUIThMeta?.path ?? "/en/composer/:slug()/workcourse",
    meta: workcoursenJSthwUIThMeta || {},
    alias: workcoursenJSthwUIThMeta?.alias || [],
    redirect: workcoursenJSthwUIThMeta?.redirect || undefined,
    component: () => import("/app/pages/composer/[slug]/workcourse.vue").then(m => m.default || m)
  },
  {
    name: worksByDateZpylvvlo1rMeta?.name ?? "composer-slug-worksByDate",
    path: worksByDateZpylvvlo1rMeta?.path ?? "/composer/:slug()/worksByDate",
    meta: worksByDateZpylvvlo1rMeta || {},
    alias: worksByDateZpylvvlo1rMeta?.alias || [],
    redirect: worksByDateZpylvvlo1rMeta?.redirect || undefined,
    component: () => import("/app/pages/composer/[slug]/worksByDate.vue").then(m => m.default || m)
  },
  {
    name: worksByDateZpylvvlo1rMeta?.name ?? "composer-slug-worksByDate___fr",
    path: worksByDateZpylvvlo1rMeta?.path ?? "/fr/composer/:slug()/worksByDate",
    meta: worksByDateZpylvvlo1rMeta || {},
    alias: worksByDateZpylvvlo1rMeta?.alias || [],
    redirect: worksByDateZpylvvlo1rMeta?.redirect || undefined,
    component: () => import("/app/pages/composer/[slug]/worksByDate.vue").then(m => m.default || m)
  },
  {
    name: worksByDateZpylvvlo1rMeta?.name ?? "composer-slug-worksByDate___en",
    path: worksByDateZpylvvlo1rMeta?.path ?? "/en/composer/:slug()/worksByDate",
    meta: worksByDateZpylvvlo1rMeta || {},
    alias: worksByDateZpylvvlo1rMeta?.alias || [],
    redirect: worksByDateZpylvvlo1rMeta?.redirect || undefined,
    component: () => import("/app/pages/composer/[slug]/worksByDate.vue").then(m => m.default || m)
  },
  {
    name: worksByKindTSEan2czuIMeta?.name ?? "composer-slug-worksByKind",
    path: worksByKindTSEan2czuIMeta?.path ?? "/composer/:slug()/worksByKind",
    meta: worksByKindTSEan2czuIMeta || {},
    alias: worksByKindTSEan2czuIMeta?.alias || [],
    redirect: worksByKindTSEan2czuIMeta?.redirect || undefined,
    component: () => import("/app/pages/composer/[slug]/worksByKind.vue").then(m => m.default || m)
  },
  {
    name: worksByKindTSEan2czuIMeta?.name ?? "composer-slug-worksByKind___fr",
    path: worksByKindTSEan2czuIMeta?.path ?? "/fr/composer/:slug()/worksByKind",
    meta: worksByKindTSEan2czuIMeta || {},
    alias: worksByKindTSEan2czuIMeta?.alias || [],
    redirect: worksByKindTSEan2czuIMeta?.redirect || undefined,
    component: () => import("/app/pages/composer/[slug]/worksByKind.vue").then(m => m.default || m)
  },
  {
    name: worksByKindTSEan2czuIMeta?.name ?? "composer-slug-worksByKind___en",
    path: worksByKindTSEan2czuIMeta?.path ?? "/en/composer/:slug()/worksByKind",
    meta: worksByKindTSEan2czuIMeta || {},
    alias: worksByKindTSEan2czuIMeta?.alias || [],
    redirect: worksByKindTSEan2czuIMeta?.redirect || undefined,
    component: () => import("/app/pages/composer/[slug]/worksByKind.vue").then(m => m.default || m)
  },
  {
    name: _91slug_93NHBz7ClbRgMeta?.name ?? "composers-composers-slug",
    path: _91slug_93NHBz7ClbRgMeta?.path ?? "/composers/composers/:slug()",
    meta: _91slug_93NHBz7ClbRgMeta || {},
    alias: _91slug_93NHBz7ClbRgMeta?.alias || [],
    redirect: _91slug_93NHBz7ClbRgMeta?.redirect || undefined,
    component: () => import("/app/pages/composers/composers/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93NHBz7ClbRgMeta?.name ?? "composers-composers-slug___fr",
    path: _91slug_93NHBz7ClbRgMeta?.path ?? "/fr/composers/composers/:slug()",
    meta: _91slug_93NHBz7ClbRgMeta || {},
    alias: _91slug_93NHBz7ClbRgMeta?.alias || [],
    redirect: _91slug_93NHBz7ClbRgMeta?.redirect || undefined,
    component: () => import("/app/pages/composers/composers/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93NHBz7ClbRgMeta?.name ?? "composers-composers-slug___en",
    path: _91slug_93NHBz7ClbRgMeta?.path ?? "/en/composers/composers/:slug()",
    meta: _91slug_93NHBz7ClbRgMeta || {},
    alias: _91slug_93NHBz7ClbRgMeta?.alias || [],
    redirect: _91slug_93NHBz7ClbRgMeta?.redirect || undefined,
    component: () => import("/app/pages/composers/composers/[slug].vue").then(m => m.default || m)
  },
  {
    name: contactV6oPJjs9RyMeta?.name ?? "contact",
    path: contactV6oPJjs9RyMeta?.path ?? "/contact",
    meta: contactV6oPJjs9RyMeta || {},
    alias: contactV6oPJjs9RyMeta?.alias || [],
    redirect: contactV6oPJjs9RyMeta?.redirect || undefined,
    component: () => import("/app/pages/contact.vue").then(m => m.default || m)
  },
  {
    name: contactV6oPJjs9RyMeta?.name ?? "contact___fr",
    path: contactV6oPJjs9RyMeta?.path ?? "/fr/contact",
    meta: contactV6oPJjs9RyMeta || {},
    alias: contactV6oPJjs9RyMeta?.alias || [],
    redirect: contactV6oPJjs9RyMeta?.redirect || undefined,
    component: () => import("/app/pages/contact.vue").then(m => m.default || m)
  },
  {
    name: contactV6oPJjs9RyMeta?.name ?? "contact___en",
    path: contactV6oPJjs9RyMeta?.path ?? "/en/contact",
    meta: contactV6oPJjs9RyMeta || {},
    alias: contactV6oPJjs9RyMeta?.alias || [],
    redirect: contactV6oPJjs9RyMeta?.redirect || undefined,
    component: () => import("/app/pages/contact.vue").then(m => m.default || m)
  },
  {
    name: _91slug_93KhwtoMY9GMMeta?.name ?? "definition-slug",
    path: _91slug_93KhwtoMY9GMMeta?.path ?? "/definition/:slug()",
    meta: _91slug_93KhwtoMY9GMMeta || {},
    alias: _91slug_93KhwtoMY9GMMeta?.alias || [],
    redirect: _91slug_93KhwtoMY9GMMeta?.redirect || undefined,
    component: () => import("/app/pages/definition/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93KhwtoMY9GMMeta?.name ?? "definition-slug___fr",
    path: _91slug_93KhwtoMY9GMMeta?.path ?? "/fr/definition/:slug()",
    meta: _91slug_93KhwtoMY9GMMeta || {},
    alias: _91slug_93KhwtoMY9GMMeta?.alias || [],
    redirect: _91slug_93KhwtoMY9GMMeta?.redirect || undefined,
    component: () => import("/app/pages/definition/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93KhwtoMY9GMMeta?.name ?? "definition-slug___en",
    path: _91slug_93KhwtoMY9GMMeta?.path ?? "/en/definition/:slug()",
    meta: _91slug_93KhwtoMY9GMMeta || {},
    alias: _91slug_93KhwtoMY9GMMeta?.alias || [],
    redirect: _91slug_93KhwtoMY9GMMeta?.redirect || undefined,
    component: () => import("/app/pages/definition/[slug].vue").then(m => m.default || m)
  },
  {
    name: definitions8WbLVtnOv1Meta?.name ?? "definitions",
    path: definitions8WbLVtnOv1Meta?.path ?? "/definitions",
    meta: definitions8WbLVtnOv1Meta || {},
    alias: definitions8WbLVtnOv1Meta?.alias || [],
    redirect: definitions8WbLVtnOv1Meta?.redirect || undefined,
    component: () => import("/app/pages/definitions.vue").then(m => m.default || m)
  },
  {
    name: definitions8WbLVtnOv1Meta?.name ?? "definitions___fr",
    path: definitions8WbLVtnOv1Meta?.path ?? "/fr/definitions",
    meta: definitions8WbLVtnOv1Meta || {},
    alias: definitions8WbLVtnOv1Meta?.alias || [],
    redirect: definitions8WbLVtnOv1Meta?.redirect || undefined,
    component: () => import("/app/pages/definitions.vue").then(m => m.default || m)
  },
  {
    name: definitions8WbLVtnOv1Meta?.name ?? "definitions___en",
    path: definitions8WbLVtnOv1Meta?.path ?? "/en/definitions",
    meta: definitions8WbLVtnOv1Meta || {},
    alias: definitions8WbLVtnOv1Meta?.alias || [],
    redirect: definitions8WbLVtnOv1Meta?.redirect || undefined,
    component: () => import("/app/pages/definitions.vue").then(m => m.default || m)
  },
  {
    name: _91slug_93QehARZdqsPMeta?.name ?? "embed-media-slug",
    path: _91slug_93QehARZdqsPMeta?.path ?? "/embed/media/:slug()",
    meta: _91slug_93QehARZdqsPMeta || {},
    alias: _91slug_93QehARZdqsPMeta?.alias || [],
    redirect: _91slug_93QehARZdqsPMeta?.redirect || undefined,
    component: () => import("/app/pages/embed/media/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93QehARZdqsPMeta?.name ?? "embed-media-slug___fr",
    path: _91slug_93QehARZdqsPMeta?.path ?? "/fr/embed/media/:slug()",
    meta: _91slug_93QehARZdqsPMeta || {},
    alias: _91slug_93QehARZdqsPMeta?.alias || [],
    redirect: _91slug_93QehARZdqsPMeta?.redirect || undefined,
    component: () => import("/app/pages/embed/media/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93QehARZdqsPMeta?.name ?? "embed-media-slug___en",
    path: _91slug_93QehARZdqsPMeta?.path ?? "/en/embed/media/:slug()",
    meta: _91slug_93QehARZdqsPMeta || {},
    alias: _91slug_93QehARZdqsPMeta?.alias || [],
    redirect: _91slug_93QehARZdqsPMeta?.redirect || undefined,
    component: () => import("/app/pages/embed/media/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93sUbkJDVPd1Meta?.name ?? "event-slug",
    path: _91slug_93sUbkJDVPd1Meta?.path ?? "/event/:slug()",
    meta: _91slug_93sUbkJDVPd1Meta || {},
    alias: _91slug_93sUbkJDVPd1Meta?.alias || [],
    redirect: _91slug_93sUbkJDVPd1Meta?.redirect || undefined,
    component: () => import("/app/pages/event/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93sUbkJDVPd1Meta?.name ?? "event-slug___fr",
    path: _91slug_93sUbkJDVPd1Meta?.path ?? "/fr/event/:slug()",
    meta: _91slug_93sUbkJDVPd1Meta || {},
    alias: _91slug_93sUbkJDVPd1Meta?.alias || [],
    redirect: _91slug_93sUbkJDVPd1Meta?.redirect || undefined,
    component: () => import("/app/pages/event/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93sUbkJDVPd1Meta?.name ?? "event-slug___en",
    path: _91slug_93sUbkJDVPd1Meta?.path ?? "/en/event/:slug()",
    meta: _91slug_93sUbkJDVPd1Meta || {},
    alias: _91slug_93sUbkJDVPd1Meta?.alias || [],
    redirect: _91slug_93sUbkJDVPd1Meta?.redirect || undefined,
    component: () => import("/app/pages/event/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93PTnCmSABQJMeta?.name ?? "flat-slug",
    path: _91slug_93PTnCmSABQJMeta?.path ?? "/flat/:slug()",
    meta: _91slug_93PTnCmSABQJMeta || {},
    alias: _91slug_93PTnCmSABQJMeta?.alias || [],
    redirect: _91slug_93PTnCmSABQJMeta?.redirect || undefined,
    component: () => import("/app/pages/flat/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93PTnCmSABQJMeta?.name ?? "flat-slug___fr",
    path: _91slug_93PTnCmSABQJMeta?.path ?? "/fr/flat/:slug()",
    meta: _91slug_93PTnCmSABQJMeta || {},
    alias: _91slug_93PTnCmSABQJMeta?.alias || [],
    redirect: _91slug_93PTnCmSABQJMeta?.redirect || undefined,
    component: () => import("/app/pages/flat/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93PTnCmSABQJMeta?.name ?? "flat-slug___en",
    path: _91slug_93PTnCmSABQJMeta?.path ?? "/en/flat/:slug()",
    meta: _91slug_93PTnCmSABQJMeta || {},
    alias: _91slug_93PTnCmSABQJMeta?.alias || [],
    redirect: _91slug_93PTnCmSABQJMeta?.redirect || undefined,
    component: () => import("/app/pages/flat/[slug].vue").then(m => m.default || m)
  },
  {
    name: booking_successd8xK3jDOUgMeta?.name ?? "flora-slug-booking_success",
    path: booking_successd8xK3jDOUgMeta?.path ?? "/flora/:slug()/booking_success",
    meta: booking_successd8xK3jDOUgMeta || {},
    alias: booking_successd8xK3jDOUgMeta?.alias || [],
    redirect: booking_successd8xK3jDOUgMeta?.redirect || undefined,
    component: () => import("/app/pages/flora/[slug]/booking_success.vue").then(m => m.default || m)
  },
  {
    name: booking_successd8xK3jDOUgMeta?.name ?? "flora-slug-booking_success___fr",
    path: booking_successd8xK3jDOUgMeta?.path ?? "/fr/flora/:slug()/booking_success",
    meta: booking_successd8xK3jDOUgMeta || {},
    alias: booking_successd8xK3jDOUgMeta?.alias || [],
    redirect: booking_successd8xK3jDOUgMeta?.redirect || undefined,
    component: () => import("/app/pages/flora/[slug]/booking_success.vue").then(m => m.default || m)
  },
  {
    name: booking_successd8xK3jDOUgMeta?.name ?? "flora-slug-booking_success___en",
    path: booking_successd8xK3jDOUgMeta?.path ?? "/en/flora/:slug()/booking_success",
    meta: booking_successd8xK3jDOUgMeta || {},
    alias: booking_successd8xK3jDOUgMeta?.alias || [],
    redirect: booking_successd8xK3jDOUgMeta?.redirect || undefined,
    component: () => import("/app/pages/flora/[slug]/booking_success.vue").then(m => m.default || m)
  },
  {
    name: bookingOdokhe63JgMeta?.name ?? "flora-slug-booking",
    path: bookingOdokhe63JgMeta?.path ?? "/flora/:slug()/booking",
    meta: bookingOdokhe63JgMeta || {},
    alias: bookingOdokhe63JgMeta?.alias || [],
    redirect: bookingOdokhe63JgMeta?.redirect || undefined,
    component: () => import("/app/pages/flora/[slug]/booking.vue").then(m => m.default || m)
  },
  {
    name: bookingOdokhe63JgMeta?.name ?? "flora-slug-booking___fr",
    path: bookingOdokhe63JgMeta?.path ?? "/fr/flora/:slug()/booking",
    meta: bookingOdokhe63JgMeta || {},
    alias: bookingOdokhe63JgMeta?.alias || [],
    redirect: bookingOdokhe63JgMeta?.redirect || undefined,
    component: () => import("/app/pages/flora/[slug]/booking.vue").then(m => m.default || m)
  },
  {
    name: bookingOdokhe63JgMeta?.name ?? "flora-slug-booking___en",
    path: bookingOdokhe63JgMeta?.path ?? "/en/flora/:slug()/booking",
    meta: bookingOdokhe63JgMeta || {},
    alias: bookingOdokhe63JgMeta?.alias || [],
    redirect: bookingOdokhe63JgMeta?.redirect || undefined,
    component: () => import("/app/pages/flora/[slug]/booking.vue").then(m => m.default || m)
  },
  {
    name: indexC65UD917tYMeta?.name ?? "flora-slug",
    path: indexC65UD917tYMeta?.path ?? "/flora/:slug()",
    meta: indexC65UD917tYMeta || {},
    alias: indexC65UD917tYMeta?.alias || [],
    redirect: indexC65UD917tYMeta?.redirect || undefined,
    component: () => import("/app/pages/flora/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexC65UD917tYMeta?.name ?? "flora-slug___fr",
    path: indexC65UD917tYMeta?.path ?? "/fr/flora/:slug()",
    meta: indexC65UD917tYMeta || {},
    alias: indexC65UD917tYMeta?.alias || [],
    redirect: indexC65UD917tYMeta?.redirect || undefined,
    component: () => import("/app/pages/flora/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexC65UD917tYMeta?.name ?? "flora-slug___en",
    path: indexC65UD917tYMeta?.path ?? "/en/flora/:slug()",
    meta: indexC65UD917tYMeta || {},
    alias: indexC65UD917tYMeta?.alias || [],
    redirect: indexC65UD917tYMeta?.redirect || undefined,
    component: () => import("/app/pages/flora/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: composersE7TAIwFus9Meta?.name ?? "index-items-composers",
    path: composersE7TAIwFus9Meta?.path ?? "/index-items/composers",
    meta: composersE7TAIwFus9Meta || {},
    alias: composersE7TAIwFus9Meta?.alias || [],
    redirect: composersE7TAIwFus9Meta?.redirect || undefined,
    component: () => import("/app/pages/index-items/composers.vue").then(m => m.default || m)
  },
  {
    name: composersE7TAIwFus9Meta?.name ?? "index-items-composers___fr",
    path: composersE7TAIwFus9Meta?.path ?? "/fr/index-items/composers",
    meta: composersE7TAIwFus9Meta || {},
    alias: composersE7TAIwFus9Meta?.alias || [],
    redirect: composersE7TAIwFus9Meta?.redirect || undefined,
    component: () => import("/app/pages/index-items/composers.vue").then(m => m.default || m)
  },
  {
    name: composersE7TAIwFus9Meta?.name ?? "index-items-composers___en",
    path: composersE7TAIwFus9Meta?.path ?? "/en/index-items/composers",
    meta: composersE7TAIwFus9Meta || {},
    alias: composersE7TAIwFus9Meta?.alias || [],
    redirect: composersE7TAIwFus9Meta?.redirect || undefined,
    component: () => import("/app/pages/index-items/composers.vue").then(m => m.default || m)
  },
  {
    name: worksm7VtpSH8qOMeta?.name ?? "index-items-works",
    path: worksm7VtpSH8qOMeta?.path ?? "/index-items/works",
    meta: worksm7VtpSH8qOMeta || {},
    alias: worksm7VtpSH8qOMeta?.alias || [],
    redirect: worksm7VtpSH8qOMeta?.redirect || undefined,
    component: () => import("/app/pages/index-items/works.vue").then(m => m.default || m)
  },
  {
    name: worksm7VtpSH8qOMeta?.name ?? "index-items-works___fr",
    path: worksm7VtpSH8qOMeta?.path ?? "/fr/index-items/works",
    meta: worksm7VtpSH8qOMeta || {},
    alias: worksm7VtpSH8qOMeta?.alias || [],
    redirect: worksm7VtpSH8qOMeta?.redirect || undefined,
    component: () => import("/app/pages/index-items/works.vue").then(m => m.default || m)
  },
  {
    name: worksm7VtpSH8qOMeta?.name ?? "index-items-works___en",
    path: worksm7VtpSH8qOMeta?.path ?? "/en/index-items/works",
    meta: worksm7VtpSH8qOMeta || {},
    alias: worksm7VtpSH8qOMeta?.alias || [],
    redirect: worksm7VtpSH8qOMeta?.redirect || undefined,
    component: () => import("/app/pages/index-items/works.vue").then(m => m.default || m)
  },
  {
    name: indexN6pT4Un8hYMeta?.name ?? "index",
    path: indexN6pT4Un8hYMeta?.path ?? "/",
    meta: indexN6pT4Un8hYMeta || {},
    alias: indexN6pT4Un8hYMeta?.alias || [],
    redirect: indexN6pT4Un8hYMeta?.redirect || undefined,
    component: () => import("/app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexN6pT4Un8hYMeta?.name ?? "index___fr",
    path: indexN6pT4Un8hYMeta?.path ?? "/fr",
    meta: indexN6pT4Un8hYMeta || {},
    alias: indexN6pT4Un8hYMeta?.alias || [],
    redirect: indexN6pT4Un8hYMeta?.redirect || undefined,
    component: () => import("/app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexN6pT4Un8hYMeta?.name ?? "index___en",
    path: indexN6pT4Un8hYMeta?.path ?? "/en",
    meta: indexN6pT4Un8hYMeta || {},
    alias: indexN6pT4Un8hYMeta?.alias || [],
    redirect: indexN6pT4Un8hYMeta?.redirect || undefined,
    component: () => import("/app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: _91slug_93GP8jY736bZMeta?.name ?? "media-slug",
    path: _91slug_93GP8jY736bZMeta?.path ?? "/media/:slug()",
    meta: _91slug_93GP8jY736bZMeta || {},
    alias: _91slug_93GP8jY736bZMeta?.alias || [],
    redirect: _91slug_93GP8jY736bZMeta?.redirect || undefined,
    component: () => import("/app/pages/media/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93GP8jY736bZMeta?.name ?? "media-slug___fr",
    path: _91slug_93GP8jY736bZMeta?.path ?? "/fr/media/:slug()",
    meta: _91slug_93GP8jY736bZMeta || {},
    alias: _91slug_93GP8jY736bZMeta?.alias || [],
    redirect: _91slug_93GP8jY736bZMeta?.redirect || undefined,
    component: () => import("/app/pages/media/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93GP8jY736bZMeta?.name ?? "media-slug___en",
    path: _91slug_93GP8jY736bZMeta?.path ?? "/en/media/:slug()",
    meta: _91slug_93GP8jY736bZMeta || {},
    alias: _91slug_93GP8jY736bZMeta?.alias || [],
    redirect: _91slug_93GP8jY736bZMeta?.redirect || undefined,
    component: () => import("/app/pages/media/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93lbuAbjEt1cMeta?.name ?? "numericDocument-slug",
    path: _91slug_93lbuAbjEt1cMeta?.path ?? "/numericDocument/:slug()",
    meta: _91slug_93lbuAbjEt1cMeta || {},
    alias: _91slug_93lbuAbjEt1cMeta?.alias || [],
    redirect: _91slug_93lbuAbjEt1cMeta?.redirect || undefined,
    component: () => import("/app/pages/numericDocument/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93lbuAbjEt1cMeta?.name ?? "numericDocument-slug___fr",
    path: _91slug_93lbuAbjEt1cMeta?.path ?? "/fr/numericDocument/:slug()",
    meta: _91slug_93lbuAbjEt1cMeta || {},
    alias: _91slug_93lbuAbjEt1cMeta?.alias || [],
    redirect: _91slug_93lbuAbjEt1cMeta?.redirect || undefined,
    component: () => import("/app/pages/numericDocument/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93lbuAbjEt1cMeta?.name ?? "numericDocument-slug___en",
    path: _91slug_93lbuAbjEt1cMeta?.path ?? "/en/numericDocument/:slug()",
    meta: _91slug_93lbuAbjEt1cMeta || {},
    alias: _91slug_93lbuAbjEt1cMeta?.alias || [],
    redirect: _91slug_93lbuAbjEt1cMeta?.redirect || undefined,
    component: () => import("/app/pages/numericDocument/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93h62tM3CXS2Meta?.name ?? "person-slug",
    path: _91slug_93h62tM3CXS2Meta?.path ?? "/person/:slug()",
    meta: _91slug_93h62tM3CXS2Meta || {},
    alias: _91slug_93h62tM3CXS2Meta?.alias || [],
    redirect: _91slug_93h62tM3CXS2Meta?.redirect || undefined,
    component: () => import("/app/pages/person/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93h62tM3CXS2Meta?.name ?? "person-slug___fr",
    path: _91slug_93h62tM3CXS2Meta?.path ?? "/fr/person/:slug()",
    meta: _91slug_93h62tM3CXS2Meta || {},
    alias: _91slug_93h62tM3CXS2Meta?.alias || [],
    redirect: _91slug_93h62tM3CXS2Meta?.redirect || undefined,
    component: () => import("/app/pages/person/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93h62tM3CXS2Meta?.name ?? "person-slug___en",
    path: _91slug_93h62tM3CXS2Meta?.path ?? "/en/person/:slug()",
    meta: _91slug_93h62tM3CXS2Meta || {},
    alias: _91slug_93h62tM3CXS2Meta?.alias || [],
    redirect: _91slug_93h62tM3CXS2Meta?.redirect || undefined,
    component: () => import("/app/pages/person/[slug].vue").then(m => m.default || m)
  },
  {
    name: search_resultg4a88VlqozMeta?.name ?? "search_result",
    path: search_resultg4a88VlqozMeta?.path ?? "/search_result",
    meta: search_resultg4a88VlqozMeta || {},
    alias: search_resultg4a88VlqozMeta?.alias || [],
    redirect: search_resultg4a88VlqozMeta?.redirect || undefined,
    component: () => import("/app/pages/search_result.vue").then(m => m.default || m)
  },
  {
    name: search_resultg4a88VlqozMeta?.name ?? "search_result___fr",
    path: search_resultg4a88VlqozMeta?.path ?? "/fr/search_result",
    meta: search_resultg4a88VlqozMeta || {},
    alias: search_resultg4a88VlqozMeta?.alias || [],
    redirect: search_resultg4a88VlqozMeta?.redirect || undefined,
    component: () => import("/app/pages/search_result.vue").then(m => m.default || m)
  },
  {
    name: search_resultg4a88VlqozMeta?.name ?? "search_result___en",
    path: search_resultg4a88VlqozMeta?.path ?? "/en/search_result",
    meta: search_resultg4a88VlqozMeta || {},
    alias: search_resultg4a88VlqozMeta?.alias || [],
    redirect: search_resultg4a88VlqozMeta?.redirect || undefined,
    component: () => import("/app/pages/search_result.vue").then(m => m.default || m)
  },
  {
    name: search_staff4VEn8lkVdSMeta?.name ?? "search_staff",
    path: search_staff4VEn8lkVdSMeta?.path ?? "/search_staff",
    meta: search_staff4VEn8lkVdSMeta || {},
    alias: search_staff4VEn8lkVdSMeta?.alias || [],
    redirect: search_staff4VEn8lkVdSMeta?.redirect || undefined,
    component: () => import("/app/pages/search_staff.vue").then(m => m.default || m)
  },
  {
    name: search_staff4VEn8lkVdSMeta?.name ?? "search_staff___fr",
    path: search_staff4VEn8lkVdSMeta?.path ?? "/fr/search_staff",
    meta: search_staff4VEn8lkVdSMeta || {},
    alias: search_staff4VEn8lkVdSMeta?.alias || [],
    redirect: search_staff4VEn8lkVdSMeta?.redirect || undefined,
    component: () => import("/app/pages/search_staff.vue").then(m => m.default || m)
  },
  {
    name: search_staff4VEn8lkVdSMeta?.name ?? "search_staff___en",
    path: search_staff4VEn8lkVdSMeta?.path ?? "/en/search_staff",
    meta: search_staff4VEn8lkVdSMeta || {},
    alias: search_staff4VEn8lkVdSMeta?.alias || [],
    redirect: search_staff4VEn8lkVdSMeta?.redirect || undefined,
    component: () => import("/app/pages/search_staff.vue").then(m => m.default || m)
  },
  {
    name: _91slug_934e0AdxEPcrMeta?.name ?? "set-slug",
    path: _91slug_934e0AdxEPcrMeta?.path ?? "/set/:slug()",
    meta: _91slug_934e0AdxEPcrMeta || {},
    alias: _91slug_934e0AdxEPcrMeta?.alias || [],
    redirect: _91slug_934e0AdxEPcrMeta?.redirect || undefined,
    component: () => import("/app/pages/set/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_934e0AdxEPcrMeta?.name ?? "set-slug___fr",
    path: _91slug_934e0AdxEPcrMeta?.path ?? "/fr/set/:slug()",
    meta: _91slug_934e0AdxEPcrMeta || {},
    alias: _91slug_934e0AdxEPcrMeta?.alias || [],
    redirect: _91slug_934e0AdxEPcrMeta?.redirect || undefined,
    component: () => import("/app/pages/set/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_934e0AdxEPcrMeta?.name ?? "set-slug___en",
    path: _91slug_934e0AdxEPcrMeta?.path ?? "/en/set/:slug()",
    meta: _91slug_934e0AdxEPcrMeta || {},
    alias: _91slug_934e0AdxEPcrMeta?.alias || [],
    redirect: _91slug_934e0AdxEPcrMeta?.redirect || undefined,
    component: () => import("/app/pages/set/[slug].vue").then(m => m.default || m)
  },
  {
    name: covercUP5VZK71cMeta?.name ?? "sidney-slug-cover",
    path: covercUP5VZK71cMeta?.path ?? "/sidney/:slug()/cover",
    meta: covercUP5VZK71cMeta || {},
    alias: covercUP5VZK71cMeta?.alias || [],
    redirect: covercUP5VZK71cMeta?.redirect || undefined,
    component: () => import("/app/pages/sidney/[slug]/cover.vue").then(m => m.default || m)
  },
  {
    name: covercUP5VZK71cMeta?.name ?? "sidney-slug-cover___fr",
    path: covercUP5VZK71cMeta?.path ?? "/fr/sidney/:slug()/cover",
    meta: covercUP5VZK71cMeta || {},
    alias: covercUP5VZK71cMeta?.alias || [],
    redirect: covercUP5VZK71cMeta?.redirect || undefined,
    component: () => import("/app/pages/sidney/[slug]/cover.vue").then(m => m.default || m)
  },
  {
    name: covercUP5VZK71cMeta?.name ?? "sidney-slug-cover___en",
    path: covercUP5VZK71cMeta?.path ?? "/en/sidney/:slug()/cover",
    meta: covercUP5VZK71cMeta || {},
    alias: covercUP5VZK71cMeta?.alias || [],
    redirect: covercUP5VZK71cMeta?.redirect || undefined,
    component: () => import("/app/pages/sidney/[slug]/cover.vue").then(m => m.default || m)
  },
  {
    name: indexuWXLMxq3TpMeta?.name ?? "sidney-slug",
    path: indexuWXLMxq3TpMeta?.path ?? "/sidney/:slug()",
    meta: indexuWXLMxq3TpMeta || {},
    alias: indexuWXLMxq3TpMeta?.alias || [],
    redirect: indexuWXLMxq3TpMeta?.redirect || undefined,
    component: () => import("/app/pages/sidney/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexuWXLMxq3TpMeta?.name ?? "sidney-slug___fr",
    path: indexuWXLMxq3TpMeta?.path ?? "/fr/sidney/:slug()",
    meta: indexuWXLMxq3TpMeta || {},
    alias: indexuWXLMxq3TpMeta?.alias || [],
    redirect: indexuWXLMxq3TpMeta?.redirect || undefined,
    component: () => import("/app/pages/sidney/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexuWXLMxq3TpMeta?.name ?? "sidney-slug___en",
    path: indexuWXLMxq3TpMeta?.path ?? "/en/sidney/:slug()",
    meta: indexuWXLMxq3TpMeta || {},
    alias: indexuWXLMxq3TpMeta?.alias || [],
    redirect: indexuWXLMxq3TpMeta?.redirect || undefined,
    component: () => import("/app/pages/sidney/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: surveyDkY5SrbsmrMeta?.name ?? "sidney-slug-survey",
    path: surveyDkY5SrbsmrMeta?.path ?? "/sidney/:slug()/survey",
    meta: surveyDkY5SrbsmrMeta || {},
    alias: surveyDkY5SrbsmrMeta?.alias || [],
    redirect: surveyDkY5SrbsmrMeta?.redirect || undefined,
    component: () => import("/app/pages/sidney/[slug]/survey.vue").then(m => m.default || m)
  },
  {
    name: surveyDkY5SrbsmrMeta?.name ?? "sidney-slug-survey___fr",
    path: surveyDkY5SrbsmrMeta?.path ?? "/fr/sidney/:slug()/survey",
    meta: surveyDkY5SrbsmrMeta || {},
    alias: surveyDkY5SrbsmrMeta?.alias || [],
    redirect: surveyDkY5SrbsmrMeta?.redirect || undefined,
    component: () => import("/app/pages/sidney/[slug]/survey.vue").then(m => m.default || m)
  },
  {
    name: surveyDkY5SrbsmrMeta?.name ?? "sidney-slug-survey___en",
    path: surveyDkY5SrbsmrMeta?.path ?? "/en/sidney/:slug()/survey",
    meta: surveyDkY5SrbsmrMeta || {},
    alias: surveyDkY5SrbsmrMeta?.alias || [],
    redirect: surveyDkY5SrbsmrMeta?.redirect || undefined,
    component: () => import("/app/pages/sidney/[slug]/survey.vue").then(m => m.default || m)
  },
  {
    name: _91slug_93CfyP7wAjcNMeta?.name ?? "sidney-brands-slug",
    path: _91slug_93CfyP7wAjcNMeta?.path ?? "/sidney/brands/:slug()",
    meta: _91slug_93CfyP7wAjcNMeta || {},
    alias: _91slug_93CfyP7wAjcNMeta?.alias || [],
    redirect: _91slug_93CfyP7wAjcNMeta?.redirect || undefined,
    component: () => import("/app/pages/sidney/brands/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93CfyP7wAjcNMeta?.name ?? "sidney-brands-slug___fr",
    path: _91slug_93CfyP7wAjcNMeta?.path ?? "/fr/sidney/brands/:slug()",
    meta: _91slug_93CfyP7wAjcNMeta || {},
    alias: _91slug_93CfyP7wAjcNMeta?.alias || [],
    redirect: _91slug_93CfyP7wAjcNMeta?.redirect || undefined,
    component: () => import("/app/pages/sidney/brands/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93CfyP7wAjcNMeta?.name ?? "sidney-brands-slug___en",
    path: _91slug_93CfyP7wAjcNMeta?.path ?? "/en/sidney/brands/:slug()",
    meta: _91slug_93CfyP7wAjcNMeta || {},
    alias: _91slug_93CfyP7wAjcNMeta?.alias || [],
    redirect: _91slug_93CfyP7wAjcNMeta?.redirect || undefined,
    component: () => import("/app/pages/sidney/brands/[slug].vue").then(m => m.default || m)
  },
  {
    name: indexEwMNvgp0VJMeta?.name ?? "sidney-brands",
    path: indexEwMNvgp0VJMeta?.path ?? "/sidney/brands",
    meta: indexEwMNvgp0VJMeta || {},
    alias: indexEwMNvgp0VJMeta?.alias || [],
    redirect: indexEwMNvgp0VJMeta?.redirect || undefined,
    component: () => import("/app/pages/sidney/brands/index.vue").then(m => m.default || m)
  },
  {
    name: indexEwMNvgp0VJMeta?.name ?? "sidney-brands___fr",
    path: indexEwMNvgp0VJMeta?.path ?? "/fr/sidney/brands",
    meta: indexEwMNvgp0VJMeta || {},
    alias: indexEwMNvgp0VJMeta?.alias || [],
    redirect: indexEwMNvgp0VJMeta?.redirect || undefined,
    component: () => import("/app/pages/sidney/brands/index.vue").then(m => m.default || m)
  },
  {
    name: indexEwMNvgp0VJMeta?.name ?? "sidney-brands___en",
    path: indexEwMNvgp0VJMeta?.path ?? "/en/sidney/brands",
    meta: indexEwMNvgp0VJMeta || {},
    alias: indexEwMNvgp0VJMeta?.alias || [],
    redirect: indexEwMNvgp0VJMeta?.redirect || undefined,
    component: () => import("/app/pages/sidney/brands/index.vue").then(m => m.default || m)
  },
  {
    name: documentation_45eniASRUu9pDpMeta?.name ?? "sidney-documentation-documentation-en",
    path: documentation_45eniASRUu9pDpMeta?.path ?? "/sidney/documentation/documentation-en",
    meta: documentation_45eniASRUu9pDpMeta || {},
    alias: documentation_45eniASRUu9pDpMeta?.alias || [],
    redirect: documentation_45eniASRUu9pDpMeta?.redirect || undefined,
    component: () => import("/app/pages/sidney/documentation/documentation-en.vue").then(m => m.default || m)
  },
  {
    name: documentation_45eniASRUu9pDpMeta?.name ?? "sidney-documentation-documentation-en___fr",
    path: documentation_45eniASRUu9pDpMeta?.path ?? "/fr/sidney/documentation/documentation-en",
    meta: documentation_45eniASRUu9pDpMeta || {},
    alias: documentation_45eniASRUu9pDpMeta?.alias || [],
    redirect: documentation_45eniASRUu9pDpMeta?.redirect || undefined,
    component: () => import("/app/pages/sidney/documentation/documentation-en.vue").then(m => m.default || m)
  },
  {
    name: documentation_45eniASRUu9pDpMeta?.name ?? "sidney-documentation-documentation-en___en",
    path: documentation_45eniASRUu9pDpMeta?.path ?? "/en/sidney/documentation/documentation-en",
    meta: documentation_45eniASRUu9pDpMeta || {},
    alias: documentation_45eniASRUu9pDpMeta?.alias || [],
    redirect: documentation_45eniASRUu9pDpMeta?.redirect || undefined,
    component: () => import("/app/pages/sidney/documentation/documentation-en.vue").then(m => m.default || m)
  },
  {
    name: documentation_45frzVu9neCdWFMeta?.name ?? "sidney-documentation-documentation-fr",
    path: documentation_45frzVu9neCdWFMeta?.path ?? "/sidney/documentation/documentation-fr",
    meta: documentation_45frzVu9neCdWFMeta || {},
    alias: documentation_45frzVu9neCdWFMeta?.alias || [],
    redirect: documentation_45frzVu9neCdWFMeta?.redirect || undefined,
    component: () => import("/app/pages/sidney/documentation/documentation-fr.vue").then(m => m.default || m)
  },
  {
    name: documentation_45frzVu9neCdWFMeta?.name ?? "sidney-documentation-documentation-fr___fr",
    path: documentation_45frzVu9neCdWFMeta?.path ?? "/fr/sidney/documentation/documentation-fr",
    meta: documentation_45frzVu9neCdWFMeta || {},
    alias: documentation_45frzVu9neCdWFMeta?.alias || [],
    redirect: documentation_45frzVu9neCdWFMeta?.redirect || undefined,
    component: () => import("/app/pages/sidney/documentation/documentation-fr.vue").then(m => m.default || m)
  },
  {
    name: documentation_45frzVu9neCdWFMeta?.name ?? "sidney-documentation-documentation-fr___en",
    path: documentation_45frzVu9neCdWFMeta?.path ?? "/en/sidney/documentation/documentation-fr",
    meta: documentation_45frzVu9neCdWFMeta || {},
    alias: documentation_45frzVu9neCdWFMeta?.alias || [],
    redirect: documentation_45frzVu9neCdWFMeta?.redirect || undefined,
    component: () => import("/app/pages/sidney/documentation/documentation-fr.vue").then(m => m.default || m)
  },
  {
    name: guidelinesLKnt9iNq8mMeta?.name ?? "sidney-documentation-guidelines",
    path: guidelinesLKnt9iNq8mMeta?.path ?? "/sidney/documentation/guidelines",
    meta: guidelinesLKnt9iNq8mMeta || {},
    alias: guidelinesLKnt9iNq8mMeta?.alias || [],
    redirect: guidelinesLKnt9iNq8mMeta?.redirect || undefined,
    component: () => import("/app/pages/sidney/documentation/guidelines.vue").then(m => m.default || m)
  },
  {
    name: guidelinesLKnt9iNq8mMeta?.name ?? "sidney-documentation-guidelines___fr",
    path: guidelinesLKnt9iNq8mMeta?.path ?? "/fr/sidney/documentation/guidelines",
    meta: guidelinesLKnt9iNq8mMeta || {},
    alias: guidelinesLKnt9iNq8mMeta?.alias || [],
    redirect: guidelinesLKnt9iNq8mMeta?.redirect || undefined,
    component: () => import("/app/pages/sidney/documentation/guidelines.vue").then(m => m.default || m)
  },
  {
    name: guidelinesLKnt9iNq8mMeta?.name ?? "sidney-documentation-guidelines___en",
    path: guidelinesLKnt9iNq8mMeta?.path ?? "/en/sidney/documentation/guidelines",
    meta: guidelinesLKnt9iNq8mMeta || {},
    alias: guidelinesLKnt9iNq8mMeta?.alias || [],
    redirect: guidelinesLKnt9iNq8mMeta?.redirect || undefined,
    component: () => import("/app/pages/sidney/documentation/guidelines.vue").then(m => m.default || m)
  },
  {
    name: index3wsCBsVyT1Meta?.name ?? "sidney",
    path: index3wsCBsVyT1Meta?.path ?? "/sidney",
    meta: index3wsCBsVyT1Meta || {},
    alias: index3wsCBsVyT1Meta?.alias || [],
    redirect: index3wsCBsVyT1Meta?.redirect || undefined,
    component: () => import("/app/pages/sidney/index.vue").then(m => m.default || m)
  },
  {
    name: index3wsCBsVyT1Meta?.name ?? "sidney___fr",
    path: index3wsCBsVyT1Meta?.path ?? "/fr/sidney",
    meta: index3wsCBsVyT1Meta || {},
    alias: index3wsCBsVyT1Meta?.alias || [],
    redirect: index3wsCBsVyT1Meta?.redirect || undefined,
    component: () => import("/app/pages/sidney/index.vue").then(m => m.default || m)
  },
  {
    name: index3wsCBsVyT1Meta?.name ?? "sidney___en",
    path: index3wsCBsVyT1Meta?.path ?? "/en/sidney",
    meta: index3wsCBsVyT1Meta || {},
    alias: index3wsCBsVyT1Meta?.alias || [],
    redirect: index3wsCBsVyT1Meta?.redirect || undefined,
    component: () => import("/app/pages/sidney/index.vue").then(m => m.default || m)
  },
  {
    name: _91slug_93rPouQJ15vxMeta?.name ?? "sidney-musicEquipments-slug",
    path: _91slug_93rPouQJ15vxMeta?.path ?? "/sidney/musicEquipments/:slug()",
    meta: _91slug_93rPouQJ15vxMeta || {},
    alias: _91slug_93rPouQJ15vxMeta?.alias || [],
    redirect: _91slug_93rPouQJ15vxMeta?.redirect || undefined,
    component: () => import("/app/pages/sidney/musicEquipments/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93rPouQJ15vxMeta?.name ?? "sidney-musicEquipments-slug___fr",
    path: _91slug_93rPouQJ15vxMeta?.path ?? "/fr/sidney/musicEquipments/:slug()",
    meta: _91slug_93rPouQJ15vxMeta || {},
    alias: _91slug_93rPouQJ15vxMeta?.alias || [],
    redirect: _91slug_93rPouQJ15vxMeta?.redirect || undefined,
    component: () => import("/app/pages/sidney/musicEquipments/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93rPouQJ15vxMeta?.name ?? "sidney-musicEquipments-slug___en",
    path: _91slug_93rPouQJ15vxMeta?.path ?? "/en/sidney/musicEquipments/:slug()",
    meta: _91slug_93rPouQJ15vxMeta || {},
    alias: _91slug_93rPouQJ15vxMeta?.alias || [],
    redirect: _91slug_93rPouQJ15vxMeta?.redirect || undefined,
    component: () => import("/app/pages/sidney/musicEquipments/[slug].vue").then(m => m.default || m)
  },
  {
    name: index7AiPpb6Fu5Meta?.name ?? "sidney-musicEquipments",
    path: index7AiPpb6Fu5Meta?.path ?? "/sidney/musicEquipments",
    meta: index7AiPpb6Fu5Meta || {},
    alias: index7AiPpb6Fu5Meta?.alias || [],
    redirect: index7AiPpb6Fu5Meta?.redirect || undefined,
    component: () => import("/app/pages/sidney/musicEquipments/index.vue").then(m => m.default || m)
  },
  {
    name: index7AiPpb6Fu5Meta?.name ?? "sidney-musicEquipments___fr",
    path: index7AiPpb6Fu5Meta?.path ?? "/fr/sidney/musicEquipments",
    meta: index7AiPpb6Fu5Meta || {},
    alias: index7AiPpb6Fu5Meta?.alias || [],
    redirect: index7AiPpb6Fu5Meta?.redirect || undefined,
    component: () => import("/app/pages/sidney/musicEquipments/index.vue").then(m => m.default || m)
  },
  {
    name: index7AiPpb6Fu5Meta?.name ?? "sidney-musicEquipments___en",
    path: index7AiPpb6Fu5Meta?.path ?? "/en/sidney/musicEquipments",
    meta: index7AiPpb6Fu5Meta || {},
    alias: index7AiPpb6Fu5Meta?.alias || [],
    redirect: index7AiPpb6Fu5Meta?.redirect || undefined,
    component: () => import("/app/pages/sidney/musicEquipments/index.vue").then(m => m.default || m)
  },
  {
    name: myVersionsHzyzmTaxCtMeta?.name ?? "sidney-myVersions",
    path: myVersionsHzyzmTaxCtMeta?.path ?? "/sidney/myVersions",
    meta: myVersionsHzyzmTaxCtMeta || {},
    alias: myVersionsHzyzmTaxCtMeta?.alias || [],
    redirect: myVersionsHzyzmTaxCtMeta?.redirect || undefined,
    component: () => import("/app/pages/sidney/myVersions.vue").then(m => m.default || m)
  },
  {
    name: myVersionsHzyzmTaxCtMeta?.name ?? "sidney-myVersions___fr",
    path: myVersionsHzyzmTaxCtMeta?.path ?? "/fr/sidney/myVersions",
    meta: myVersionsHzyzmTaxCtMeta || {},
    alias: myVersionsHzyzmTaxCtMeta?.alias || [],
    redirect: myVersionsHzyzmTaxCtMeta?.redirect || undefined,
    component: () => import("/app/pages/sidney/myVersions.vue").then(m => m.default || m)
  },
  {
    name: myVersionsHzyzmTaxCtMeta?.name ?? "sidney-myVersions___en",
    path: myVersionsHzyzmTaxCtMeta?.path ?? "/en/sidney/myVersions",
    meta: myVersionsHzyzmTaxCtMeta || {},
    alias: myVersionsHzyzmTaxCtMeta?.alias || [],
    redirect: myVersionsHzyzmTaxCtMeta?.redirect || undefined,
    component: () => import("/app/pages/sidney/myVersions.vue").then(m => m.default || m)
  },
  {
    name: _91slug_93ctQTwCVCWTMeta?.name ?? "sidney-orderby-slug",
    path: _91slug_93ctQTwCVCWTMeta?.path ?? "/sidney/orderby/:slug()",
    meta: _91slug_93ctQTwCVCWTMeta || {},
    alias: _91slug_93ctQTwCVCWTMeta?.alias || [],
    redirect: _91slug_93ctQTwCVCWTMeta?.redirect || undefined,
    component: () => import("/app/pages/sidney/orderby/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93ctQTwCVCWTMeta?.name ?? "sidney-orderby-slug___fr",
    path: _91slug_93ctQTwCVCWTMeta?.path ?? "/fr/sidney/orderby/:slug()",
    meta: _91slug_93ctQTwCVCWTMeta || {},
    alias: _91slug_93ctQTwCVCWTMeta?.alias || [],
    redirect: _91slug_93ctQTwCVCWTMeta?.redirect || undefined,
    component: () => import("/app/pages/sidney/orderby/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93ctQTwCVCWTMeta?.name ?? "sidney-orderby-slug___en",
    path: _91slug_93ctQTwCVCWTMeta?.path ?? "/en/sidney/orderby/:slug()",
    meta: _91slug_93ctQTwCVCWTMeta || {},
    alias: _91slug_93ctQTwCVCWTMeta?.alias || [],
    redirect: _91slug_93ctQTwCVCWTMeta?.redirect || undefined,
    component: () => import("/app/pages/sidney/orderby/[slug].vue").then(m => m.default || m)
  },
  {
    name: work_45without_45versionsIgQh8ABAVKMeta?.name ?? "sidney-work-without-versions",
    path: work_45without_45versionsIgQh8ABAVKMeta?.path ?? "/sidney/work-without-versions",
    meta: work_45without_45versionsIgQh8ABAVKMeta || {},
    alias: work_45without_45versionsIgQh8ABAVKMeta?.alias || [],
    redirect: work_45without_45versionsIgQh8ABAVKMeta?.redirect || undefined,
    component: () => import("/app/pages/sidney/work-without-versions.vue").then(m => m.default || m)
  },
  {
    name: work_45without_45versionsIgQh8ABAVKMeta?.name ?? "sidney-work-without-versions___fr",
    path: work_45without_45versionsIgQh8ABAVKMeta?.path ?? "/fr/sidney/work-without-versions",
    meta: work_45without_45versionsIgQh8ABAVKMeta || {},
    alias: work_45without_45versionsIgQh8ABAVKMeta?.alias || [],
    redirect: work_45without_45versionsIgQh8ABAVKMeta?.redirect || undefined,
    component: () => import("/app/pages/sidney/work-without-versions.vue").then(m => m.default || m)
  },
  {
    name: work_45without_45versionsIgQh8ABAVKMeta?.name ?? "sidney-work-without-versions___en",
    path: work_45without_45versionsIgQh8ABAVKMeta?.path ?? "/en/sidney/work-without-versions",
    meta: work_45without_45versionsIgQh8ABAVKMeta || {},
    alias: work_45without_45versionsIgQh8ABAVKMeta?.alias || [],
    redirect: work_45without_45versionsIgQh8ABAVKMeta?.redirect || undefined,
    component: () => import("/app/pages/sidney/work-without-versions.vue").then(m => m.default || m)
  },
  {
    name: workWithoutVersionVhNdjyrALVMeta?.name ?? "sidney-workWithoutVersion",
    path: workWithoutVersionVhNdjyrALVMeta?.path ?? "/sidney/workWithoutVersion",
    meta: workWithoutVersionVhNdjyrALVMeta || {},
    alias: workWithoutVersionVhNdjyrALVMeta?.alias || [],
    redirect: workWithoutVersionVhNdjyrALVMeta?.redirect || undefined,
    component: () => import("/app/pages/sidney/workWithoutVersion.vue").then(m => m.default || m)
  },
  {
    name: workWithoutVersionVhNdjyrALVMeta?.name ?? "sidney-workWithoutVersion___fr",
    path: workWithoutVersionVhNdjyrALVMeta?.path ?? "/fr/sidney/workWithoutVersion",
    meta: workWithoutVersionVhNdjyrALVMeta || {},
    alias: workWithoutVersionVhNdjyrALVMeta?.alias || [],
    redirect: workWithoutVersionVhNdjyrALVMeta?.redirect || undefined,
    component: () => import("/app/pages/sidney/workWithoutVersion.vue").then(m => m.default || m)
  },
  {
    name: workWithoutVersionVhNdjyrALVMeta?.name ?? "sidney-workWithoutVersion___en",
    path: workWithoutVersionVhNdjyrALVMeta?.path ?? "/en/sidney/workWithoutVersion",
    meta: workWithoutVersionVhNdjyrALVMeta || {},
    alias: workWithoutVersionVhNdjyrALVMeta?.alias || [],
    redirect: workWithoutVersionVhNdjyrALVMeta?.redirect || undefined,
    component: () => import("/app/pages/sidney/workWithoutVersion.vue").then(m => m.default || m)
  },
  {
    name: _91slug_936YKsg4LvdSMeta?.name ?? "tag-slug",
    path: _91slug_936YKsg4LvdSMeta?.path ?? "/tag/:slug()",
    meta: _91slug_936YKsg4LvdSMeta || {},
    alias: _91slug_936YKsg4LvdSMeta?.alias || [],
    redirect: _91slug_936YKsg4LvdSMeta?.redirect || undefined,
    component: () => import("/app/pages/tag/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_936YKsg4LvdSMeta?.name ?? "tag-slug___fr",
    path: _91slug_936YKsg4LvdSMeta?.path ?? "/fr/tag/:slug()",
    meta: _91slug_936YKsg4LvdSMeta || {},
    alias: _91slug_936YKsg4LvdSMeta?.alias || [],
    redirect: _91slug_936YKsg4LvdSMeta?.redirect || undefined,
    component: () => import("/app/pages/tag/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_936YKsg4LvdSMeta?.name ?? "tag-slug___en",
    path: _91slug_936YKsg4LvdSMeta?.path ?? "/en/tag/:slug()",
    meta: _91slug_936YKsg4LvdSMeta || {},
    alias: _91slug_936YKsg4LvdSMeta?.alias || [],
    redirect: _91slug_936YKsg4LvdSMeta?.redirect || undefined,
    component: () => import("/app/pages/tag/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93VACrgYtOUYMeta?.name ?? "video-slug",
    path: _91slug_93VACrgYtOUYMeta?.path ?? "/video/:slug()",
    meta: _91slug_93VACrgYtOUYMeta || {},
    alias: _91slug_93VACrgYtOUYMeta?.alias || [],
    redirect: _91slug_93VACrgYtOUYMeta?.redirect || undefined,
    component: () => import("/app/pages/video/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93VACrgYtOUYMeta?.name ?? "video-slug___fr",
    path: _91slug_93VACrgYtOUYMeta?.path ?? "/fr/video/:slug()",
    meta: _91slug_93VACrgYtOUYMeta || {},
    alias: _91slug_93VACrgYtOUYMeta?.alias || [],
    redirect: _91slug_93VACrgYtOUYMeta?.redirect || undefined,
    component: () => import("/app/pages/video/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93VACrgYtOUYMeta?.name ?? "video-slug___en",
    path: _91slug_93VACrgYtOUYMeta?.path ?? "/en/video/:slug()",
    meta: _91slug_93VACrgYtOUYMeta || {},
    alias: _91slug_93VACrgYtOUYMeta?.alias || [],
    redirect: _91slug_93VACrgYtOUYMeta?.redirect || undefined,
    component: () => import("/app/pages/video/[slug].vue").then(m => m.default || m)
  },
  {
    name: indexFYVBQJGfNjMeta?.name ?? "work-slug",
    path: indexFYVBQJGfNjMeta?.path ?? "/work/:slug()",
    meta: indexFYVBQJGfNjMeta || {},
    alias: indexFYVBQJGfNjMeta?.alias || [],
    redirect: indexFYVBQJGfNjMeta?.redirect || undefined,
    component: () => import("/app/pages/work/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexFYVBQJGfNjMeta?.name ?? "work-slug___fr",
    path: indexFYVBQJGfNjMeta?.path ?? "/fr/work/:slug()",
    meta: indexFYVBQJGfNjMeta || {},
    alias: indexFYVBQJGfNjMeta?.alias || [],
    redirect: indexFYVBQJGfNjMeta?.redirect || undefined,
    component: () => import("/app/pages/work/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexFYVBQJGfNjMeta?.name ?? "work-slug___en",
    path: indexFYVBQJGfNjMeta?.path ?? "/en/work/:slug()",
    meta: indexFYVBQJGfNjMeta || {},
    alias: indexFYVBQJGfNjMeta?.alias || [],
    redirect: indexFYVBQJGfNjMeta?.redirect || undefined,
    component: () => import("/app/pages/work/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: _91slug_93G10iNVRzKxMeta?.name ?? "work-composition-year-slug",
    path: _91slug_93G10iNVRzKxMeta?.path ?? "/work/composition-year/:slug()",
    meta: _91slug_93G10iNVRzKxMeta || {},
    alias: _91slug_93G10iNVRzKxMeta?.alias || [],
    redirect: _91slug_93G10iNVRzKxMeta?.redirect || undefined,
    component: () => import("/app/pages/work/composition-year/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93G10iNVRzKxMeta?.name ?? "work-composition-year-slug___fr",
    path: _91slug_93G10iNVRzKxMeta?.path ?? "/fr/work/composition-year/:slug()",
    meta: _91slug_93G10iNVRzKxMeta || {},
    alias: _91slug_93G10iNVRzKxMeta?.alias || [],
    redirect: _91slug_93G10iNVRzKxMeta?.redirect || undefined,
    component: () => import("/app/pages/work/composition-year/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93G10iNVRzKxMeta?.name ?? "work-composition-year-slug___en",
    path: _91slug_93G10iNVRzKxMeta?.path ?? "/en/work/composition-year/:slug()",
    meta: _91slug_93G10iNVRzKxMeta || {},
    alias: _91slug_93G10iNVRzKxMeta?.alias || [],
    redirect: _91slug_93G10iNVRzKxMeta?.redirect || undefined,
    component: () => import("/app/pages/work/composition-year/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93qeaeszMjUFMeta?.name ?? "work-creation-year-slug",
    path: _91slug_93qeaeszMjUFMeta?.path ?? "/work/creation-year/:slug()",
    meta: _91slug_93qeaeszMjUFMeta || {},
    alias: _91slug_93qeaeszMjUFMeta?.alias || [],
    redirect: _91slug_93qeaeszMjUFMeta?.redirect || undefined,
    component: () => import("/app/pages/work/creation-year/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93qeaeszMjUFMeta?.name ?? "work-creation-year-slug___fr",
    path: _91slug_93qeaeszMjUFMeta?.path ?? "/fr/work/creation-year/:slug()",
    meta: _91slug_93qeaeszMjUFMeta || {},
    alias: _91slug_93qeaeszMjUFMeta?.alias || [],
    redirect: _91slug_93qeaeszMjUFMeta?.redirect || undefined,
    component: () => import("/app/pages/work/creation-year/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93qeaeszMjUFMeta?.name ?? "work-creation-year-slug___en",
    path: _91slug_93qeaeszMjUFMeta?.path ?? "/en/work/creation-year/:slug()",
    meta: _91slug_93qeaeszMjUFMeta || {},
    alias: _91slug_93qeaeszMjUFMeta?.alias || [],
    redirect: _91slug_93qeaeszMjUFMeta?.redirect || undefined,
    component: () => import("/app/pages/work/creation-year/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_937z7txrvYKbMeta?.name ?? "work-genre-slug",
    path: _91slug_937z7txrvYKbMeta?.path ?? "/work/genre/:slug()",
    meta: _91slug_937z7txrvYKbMeta || {},
    alias: _91slug_937z7txrvYKbMeta?.alias || [],
    redirect: _91slug_937z7txrvYKbMeta?.redirect || undefined,
    component: () => import("/app/pages/work/genre/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_937z7txrvYKbMeta?.name ?? "work-genre-slug___fr",
    path: _91slug_937z7txrvYKbMeta?.path ?? "/fr/work/genre/:slug()",
    meta: _91slug_937z7txrvYKbMeta || {},
    alias: _91slug_937z7txrvYKbMeta?.alias || [],
    redirect: _91slug_937z7txrvYKbMeta?.redirect || undefined,
    component: () => import("/app/pages/work/genre/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_937z7txrvYKbMeta?.name ?? "work-genre-slug___en",
    path: _91slug_937z7txrvYKbMeta?.path ?? "/en/work/genre/:slug()",
    meta: _91slug_937z7txrvYKbMeta || {},
    alias: _91slug_937z7txrvYKbMeta?.alias || [],
    redirect: _91slug_937z7txrvYKbMeta?.redirect || undefined,
    component: () => import("/app/pages/work/genre/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93d283ziE4ElMeta?.name ?? "works-work-slug",
    path: _91slug_93d283ziE4ElMeta?.path ?? "/works/work/:slug()",
    meta: _91slug_93d283ziE4ElMeta || {},
    alias: _91slug_93d283ziE4ElMeta?.alias || [],
    redirect: _91slug_93d283ziE4ElMeta?.redirect || undefined,
    component: () => import("/app/pages/works/work/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93d283ziE4ElMeta?.name ?? "works-work-slug___fr",
    path: _91slug_93d283ziE4ElMeta?.path ?? "/fr/works/work/:slug()",
    meta: _91slug_93d283ziE4ElMeta || {},
    alias: _91slug_93d283ziE4ElMeta?.alias || [],
    redirect: _91slug_93d283ziE4ElMeta?.redirect || undefined,
    component: () => import("/app/pages/works/work/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93d283ziE4ElMeta?.name ?? "works-work-slug___en",
    path: _91slug_93d283ziE4ElMeta?.path ?? "/en/works/work/:slug()",
    meta: _91slug_93d283ziE4ElMeta || {},
    alias: _91slug_93d283ziE4ElMeta?.alias || [],
    redirect: _91slug_93d283ziE4ElMeta?.redirect || undefined,
    component: () => import("/app/pages/works/work/[slug].vue").then(m => m.default || m)
  }
]